import { Button, Card, Col, Input, Row, Typography } from "antd";
import React, { useEffect, useRef, useState } from "react";
import "./login.scss";
import { useNavigate } from "react-router-dom";
import { HandleErrors } from "../../../utils/handleErrors";
import {
  generateCaptchaService,
  getPublicKeyService,
  loginService,
  verifyCaptchaService,
} from "../../../services/user.service";
import {
  GenerateCaptchaRes,
  LoginReq,
} from "../../../interfaces/user.interface";
import {
  ConfigMapKey,
  GetConfigMapRes,
} from "../../../interfaces/configMap.interface";
import { getLogoConfigMapByKeyService } from "../../../services/configmap.service";
import { encrypt } from "../../../utils/encrypt";
import GoCaptcha from "go-captcha-react";

const Login = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [loginReq, setLoginReq] = useState<LoginReq>({
    password: "",
    totp: "",
    username: "",
    captcha_key: "",
  });

  const [logoConfig, setLogoConfig] = useState({} as GetConfigMapRes);

  useEffect(() => {
    getLogoConfig();
    getCaptchaImage();
  }, []);

  const login = async () => {
    try {
      const aesPublic = await getPublicKeyService({});

      const t = encrypt(
        aesPublic.public_key,
        JSON.stringify({
          username: loginReq.username,
          password: loginReq.password,
        })
      );

      setLoading(true);
      const res = await loginService({
        totp: "",
        payload: t,
        captcha_key: captcha?.key || "",
      });

      if (res.mfa_require) {
        navigate("/auth/totp", {
          state: {
            loginPayload: t,
            captchaKey: captcha?.key || "",
          },
        });
      } else {
        localStorage.setItem("accessToken", res.access_token);
        localStorage.setItem("refreshToken", res.refresh_token);
        navigate("/panel", { replace: true });
      }

      setLoading(false);
    } catch (error) {
      HandleErrors(error);
      setLoading(false);
    }
  };

  const getLogoConfig = async () => {
    try {
      setLoading(true);
      const res = await getLogoConfigMapByKeyService({
        key: ConfigMapKey.organizationLogo,
      });

      setLogoConfig(res);

      setLoading(false);
    } catch (error) {
      HandleErrors(error);
      setLoading(false);
    }
  };

  const [captcha, setCaptcha] = useState<GenerateCaptchaRes>();
  const [captchaVerify, setCaptchaVerify] = useState<any>(-1);

  const getCaptchaImage = async (resetCaptchaVerify = true) => {
    try {
      const res = await generateCaptchaService({});
      setCaptcha(res);
      if(resetCaptchaVerify){
        setCaptchaVerify(-1);
      }
      
    } catch (error) {
      HandleErrors(error);
    }
  };

  const verifyCaptcha = async (x: number, y: number) => {
    try {
      const res = await verifyCaptchaService({
        key: captcha?.key || "",
        x: x,
        y: y,
      });
      setCaptchaVerify(res.success);
      if(!res.success){
        getCaptchaImage(false)
      }
    } catch (error) {
      HandleErrors(error);
    }
  };

  return (
    <div className="Login">
      <div className="card-wrapper">
        <Card className="card">
          <Row justify={"center"}>
            <Col>
              {logoConfig?.value?.length == 0 && (
                <img src="/assets/icons/Login.svg" alt="login" />
              )}
              {logoConfig?.value?.length != 0 && (
                <img
                  className="logo"
                  src={`${(window as any).env.base_url}/images/logo.png`}
                  alt=""
                />
              )}
            </Col>
          </Row>
          <Row justify={"center"} className="title-box">
            <Col>
              <Typography className="title">
                به سامانه پارساد خوش‌آمدید!
              </Typography>
            </Col>
          </Row>
          <div className="input-box">
            <Row>
              <img src="/assets/icons/User.svg" alt="user" />
              <Typography.Text className="title">نام کاربری</Typography.Text>
            </Row>
            <Row>
              <Input
                className="input"
                placeholder="نام کاربری خود را وارد کنید"
                value={loginReq.username}
                onChange={(e) => {
                  setLoginReq({
                    ...loginReq,
                    username: e.target.value,
                  });
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    login();
                  }
                }}
              />
            </Row>
          </div>
          <div className="input-box">
            <Row>
              <img src="/assets/icons/Key.svg" alt="key" />
              <Typography.Text className="title">رمز عبور</Typography.Text>
            </Row>
            <Row>
              <Input.Password
                className="input"
                placeholder="رمز عبور خود را وارد کنید"
                value={loginReq.password}
                onChange={(e) => {
                  setLoginReq({
                    ...loginReq,
                    password: e.target.value,
                  });
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    login();
                  }
                }}
              />
            </Row>
          </div>
          <Row justify={"center"}>
            <Col>
              {!(captchaVerify == true) && (
                <GoCaptcha.Slide
                  config={{
                    width: 300,
                    height: 220,
                    scope: true,
                    title: "",
                    showTheme: false,
                  }}
                  data={{
                    image: captcha?.image || "",
                    thumb: captcha?.thumb || "",
                    thumbHeight: captcha?.thumbHeight || 0,
                    thumbWidth: captcha?.thumbWidth || 0,
                    thumbX: captcha?.thumbX || 0,
                    thumbY: captcha?.thumbY || 0,
                  }}
                  events={{
                    refresh() {
                      getCaptchaImage();
                    },
                    confirm(point, reset) {
                      verifyCaptcha(point.x, point.y);
                    },
                    close() {},
                    move(x, y) {},
                  }}
                />
              )}
              {(captchaVerify == true || captchaVerify == false) && (
                <div style={{ marginTop: 10 }}>
                  <GoCaptcha.Button
                    title={captchaVerify == true ? "چالش کپچا با موفقیت انجام شد" : "چالش کپچا  موفقیت امیز نبود"}
                    type={captchaVerify == true ? "success" : "error"}
                  ></GoCaptcha.Button>
                </div>
              )}
            </Col>
          </Row>
          <Row justify={"center"}>
            <Col xs={24}>
              <Button
                onClick={login}
                className="submit-btn"
                block
                type="primary"
                loading={loading}
                disabled={captchaVerify == -1 || captchaVerify == false}
              >
                تایید
              </Button>
            </Col>
          </Row>
        </Card>
      </div>
    </div>
  );
};

export default Login;
